export default import.meta.ROLLUP_FILE_URL_zw7G0NBW4VFaikgOCyd2Mg